// src/components/ZuttleLogo.js
//
// The real Zuttle mark, not a stand-in glyph. The auth screens were using a
// generic lucide Building2 icon in a circle, which is what a company sees first
// when they register, so it was the least on-brand surface in the product.
//
// Assets are the official SVGs from brand/Logo_SVG (see brand/BRAND.md). The
// wordmark is set in Big City Grotesque, which is commercial and not bundled,
// so it must always come from the artwork and never from live type.
import React from 'react';

const VARIANTS = {
  primary: '/brand/Zuttle_Primary.svg',
  reversed: '/brand/Zuttle_Primary_Reversed.svg',
  mono: '/brand/Zuttle_Monochromatic.svg',
  monoReversed: '/brand/Zuttle_Monochromatic_Reversed.svg',
  // Not a separate asset: the monochrome mark inverted to white. Both official
  // *_Reversed* files bake in a full-bleed background rect (ink for mono, teal
  // for primary), so they are badges meant to sit ON a light surface, not
  // transparent marks. Dropping one into the dark admin chrome renders a stray
  // rectangle in a slightly different dark than the page. The monochrome mark
  // is a single flat ink colour on transparent, so inverting it gives exactly
  // the white version with no artwork edited.
  white: '/brand/Zuttle_Monochromatic.svg',
};

/**
 * Full logo lockup (mark + wordmark).
 * `variant`: primary (default, light backgrounds) | reversed (dark/photo) |
 *            mono | monoReversed
 */
const ZuttleLogo = ({ variant = 'primary', className = '', height = 40, alt = 'Zuttle' }) => (
  <img
    src={VARIANTS[variant] || VARIANTS.primary}
    alt={alt}
    height={height}
    style={{
      height,
      width: 'auto',
      // brightness(0) flattens the mark to pure black, invert(1) then makes it
      // pure white. Only valid because the monochrome artwork is a single flat
      // colour on transparency.
      ...(variant === 'white' ? { filter: 'brightness(0) invert(1)' } : {}),
    }}
    className={className}
  />
);

export default ZuttleLogo;
